// @ts-nocheck
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useAppDispatch, useAppSelector } from "../hooks/useRedux";
import { fetchUsersBySport } from "../store/postsSlice";
import CoachItem from "../components/CoachItem";
import { BASE_URL } from "../Constants/BaseUrl";
import { Lock } from "lucide-react";

const MainSearch = ({ onClearSearch, onClear }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [form, setForm] = useState({ sport_id: null });
  const [sports, setSports] = useState([]);

  const { userBySports, loading } = useAppSelector((state) => state.posts);
  const apiResponse = useAppSelector(
    (state) => state?.posts?.allPostsApiResponse
  );

  console.log("MainSearch - apiResponse:", apiResponse);
  const isPrivateOrRestricted =
    apiResponse && !apiResponse.success && apiResponse.message;

  const getSports = () => {
    axios
      .get(`${BASE_URL}sports/all`, {
        headers: { Accept: "application/json" },
      })
      .then((response) => {
        setSports(response.data.data);
      })
      .catch((error) => {
        console.log("Error fetching sports:", error);
      });
  };

  useEffect(() => {
    getSports();
  }, []);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (value) {
      dispatch(fetchUsersBySport(value));
    }
  };

  const renderPost = ({ item }) => {
    const details = item?.athlete_details || item?.coach_details || {};
    const newItem = {
      athlete_details: {
        first_name: details.first_name || "",
        last_name: details.last_name || "",
        sports_name: details.sport_name || "",
      },
      profile_picture: item?.user_details?.profile_picture || "",
      role: item?.user_details?.role || "",
      user_id: item?.user_details?.user_id || "",
    };

    return (
      <CoachItem
        key={newItem.user_id}
        item={newItem}
        sport_name={newItem.athlete_details.sports_name}
      />
    );
  };

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center max-w-screen-md mx-auto px-4">
      {/* PRIVATE PROFILE MESSAGE */}
      {isPrivateOrRestricted ? (
        <div className="flex flex-col items-center justify-center py-20 text-center">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl p-10 max-w-md shadow-2xl">
            <Lock
              className="w-20 h-20 text-gray-500 mx-auto mb-6"
              strokeWidth={1.5}
            />

            <h2 className="text-2xl font-bold text-white mb-4">
              This Profile is Private
            </h2>

            <p className="text-gray-300 text-base leading-relaxed mb-6">
              {apiResponse.message}
            </p>

            <div className="text-sm text-gray-500 bg-gray-800 rounded-lg py-3 px-5 inline-block">
              <span className="font-medium">To make it public:</span>
              <br />
              Profile → Settings → Private/Public Profile
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* SPORT SELECTOR */}
          <div className="w-full p-4">
            <select
              className="w-full bg-black border border-gray-600 rounded-md p-4 text-white text-lg placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-600 transition"
              value={form.sport_id || ""}
              onChange={(e) => handleChange("sport_id", e.target.value)}
            >
              <option value="" disabled hidden className="text-gray-400">
                Select Sport
              </option>
              {sports
                ?.slice()
                .sort((a, b) => a.sport_name.localeCompare(b.sport_name))
                .map((item) => (
                  <option
                    key={item.id}
                    value={item.id}
                    className="text-white bg-gray-800 py-2"
                  >
                    {item.sport_name}
                  </option>
                ))}
            </select>
          </div>

          {/* LOADING OR RESULTS */}
          {loading ? (
            <div className="flex-1 flex justify-center items-center py-20">
              <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-white"></div>
            </div>
          ) : (
            <div className="flex-1 w-full pb-24">
              {userBySports?.length === 0 ? (
                <div className="flex-1 flex mt-10 justify-center items-center">
                  <span className="text-gray-400 text-lg text-center px-6">
                    {form.sport_id
                      ? "No athletes or coaches found for this sport."
                      : "Select a sport to find users."}
                  </span>
                </div>
              ) : (
                <div className="space-y-4">
                  {userBySports?.map((item) => renderPost({ item }))}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MainSearch;
